import { SessionChart, type InjectionsChartOptions } from '~/components/reports/sessionChart';

export interface SessionDataSet {
    timestamp: string;
    flow: number;
    pressure: number;
    volume: number;
    cement: number;
}
export class InjectionSession {
  injectionChart: SessionChart<SessionDataSet>;
  constructor(opts: InjectionsChartOptions) {
    this.injectionChart = new SessionChart<SessionDataSet>(opts);
    const seriesColors = ['#1395BA', '#0D3C55', '#F16C20', '#F2B705'];
    this.injectionChart
        .addSplineSeries({
            name: 'Flow (L/min)',
            color: seriesColors[0],
            formatter: value => `${value.toFixed(1)}`,
            map: (values) =>
            values.map(datasetitem => ({ x: new Date(datasetitem.timestamp).getTime(), y: datasetitem.flow })),
        })
        .addSplineSeries({
            name: 'Pressure (bar)',
            color: seriesColors[1],
            formatter: value => `${value.toFixed(1)}`,
            map: (values) =>
            values.map(datasetitem => ({ x: new Date(datasetitem.timestamp).getTime(), y: datasetitem.pressure })),
        })
        .addSplineSeries({
            name: 'Volume (L)',
            yAxis: { axis: this.injectionChart.rightYAxis, opposite: true },
            color: seriesColors[2],
            formatter: value => `${value.toFixed(0)}`,
            map: (values) =>
            values.map(datasetitem => ({ x: new Date(datasetitem.timestamp).getTime(), y: datasetitem.volume })),
        })
        .addSplineSeries({
            name: 'Cement (kg)',
            yAxis: { axis: this.injectionChart.rightYAxis, opposite: true },
            color: seriesColors[3],
            showPoints: true,
            formatter: value => `${value.toFixed(0)}`,
            map: (values) =>
            values.map(datasetitem => ({ x: new Date(datasetitem.timestamp).getTime(), y: datasetitem.cement })),
        })
        .addLegendBox(
            this.injectionChart.series.filter(s => s.series.getVisible() === true),
            undefined,
            { x: 50, y: 0 },
        )
        .addCustomCursor(this.injectionChart.xAxis, this.injectionChart.leftYAxis, this.injectionChart.rightYAxis);
  }

  add(data: SessionDataSet[]) {
    this.injectionChart.add(data);
    return this;
  }

  clear() {
    this.injectionChart.clear();
    return this;
  }
}
